import 'core-js/features/promise';
import 'core-js/features/array';
import 'core-js/features/string';
import 'unorm';
import 'classlist-polyfill';
import 'focus-within-polyfill';

import * as foreachPolyfill from './libs/foreach-polyfill';
foreachPolyfill.default();

import(
  /* webpackMode: "eager" */
  '../scss/main.scss'
);

import(/* webpackMode: "eager" */ './libs/fontawesome').then((component) =>
  component.default()
);

import(/* webpackMode: "eager" */ '../components/def-accordions').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/back-to-top').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/carousel').then((component) =>
  component.default()
);

import(/* webpackMode: "eager" */ '../components/document-links/index.ts').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/dropdowns').then((component) =>
  component.default()
);

import(/* webpackMode: "eager" */ '../components/external-links/index.ts').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/image-captions/index.ts').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/maps').then((component) =>
  component.default()
);

import(/* webpackMode: "eager" */ '../components/page-summary/index.ts').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/scroll-reveal').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/search-autocomplete').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/search-sort-onchange').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/share-buttons').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/tables').then((component) =>
  component.default()
);

import(/* webpackMode: "eager" */ '../components/video-wall').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/hvt-featured-projects').then(
  (component) => component.default()
);

// import(/* webpackMode: "eager" */ '../components/hvt-map').then((component) =>
//   component.default()
// );

// import(/* webpackMode: "eager" */ '../components/hvt-map-filter').then(
//   (component) => component.default()
// );

// import(/* webpackMode: "eager" */ '../components/hvt-map-search-bar').then(
//   (component) => component.default()
// );

// import(/* webpackMode: "eager" */ '../components/hvt-page-map-search-bar').then(
//   (component) => component.default()
// );

import(/* webpackMode: "eager" */ '../components/hvt-project-status').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/hvt-shard-button').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/hvt-site-map').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/hvt-key-facts').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/hvt-related-content').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/def-header').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/def-featured-video').then(
  (component) => component.default()
);

import(/* webpackMode: "eager" */ '../components/def-page-useful').then(
  (component) => component.default()
);
